// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../state/manageuser/actions';
import { getGroups } from '../state/domains/groups/actions';

// Components
import CreateNewUser from '../components/ManageUser/CreateNewUser';

function mapStateToProps(state) {
	return {
		newuser: state.newuser,
		user: state.newuser.user,
		groups: state.domains.groups
	};
}

function mapDispatchToProps(dispatch) {
	return { 
		actions: bindActionCreators(actions, dispatch),
		getGroups: bindActionCreators(getGroups, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewUser);


// WEBPACK FOOTER //
// ./src/containers/CreateNewUserContainer.js